import { setIsShowAppSwitcherTooltip, useAppDispatch } from 'src/store';
import { useCallback, useMemo } from 'react';

export const useAppSwitcherTooltipActions = () => {
  const dispatch = useAppDispatch();

  const toggleShowAppSwitcherTooltip = useCallback(
    (value?: boolean) => {
      dispatch(setIsShowAppSwitcherTooltip(value));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      toggleShowAppSwitcherTooltip,
    }),
    [toggleShowAppSwitcherTooltip],
  );
};
